import { type Currency } from '~/entities/currency';
import { type PayoutTraderBalance } from '~/entities/payout';

export const prepareBalance = (balances: PayoutTraderBalance[] | undefined, currency: Currency) => {
    return balances?.find((balance) => balance.currency === currency);
};
